import styled,{css} from "styled-components";
import { Colors } from "../../../../../styles/colors";

interface RadioButtonProps {
	questionAsync: boolean | undefined;
	typeRadio?: string;
	placeHolderType?: string;
}
const ICPStyle = css`
	padding: 10px ;
	border: 1px solid ${Colors.neutral_grey_k_20};
	border-radius: 12px;
	align-items: center;
	cursor: pointer;
	width: 100%;
`;

export const Radio = styled.button<RadioButtonProps>`
	display: flex;
	align-items: flex-start;
	margin-bottom:${({ typeRadio }) => typeRadio == 'ICP' ? 1 : 1.6}rem;
	margin-right: 4rem;
	background-color: transparent;
	border: 0;
	cursor: auto;
	position: relative;
	align-items: center;

	${({ questionAsync }) => questionAsync && `text-align: left;`}
	${({ typeRadio }) => typeRadio == 'ICP' ? ICPStyle : 'undefined'}
	
	label {
		cursor: pointer;
		color: #404040;
	}

	.custom-checkbox {
		margin-right: 0.5rem;

		${({ typeRadio }) => typeRadio == 'ICP' && {
				position: 'absolute',
				top: 13,
		}}
	
	}
	
	.custom-checkbox input + .label:before {
		content: "";
		width: 1rem;
		height: 1rem;
		border-radius: 20%;
		background-color: #ededed;
		border: 2px solid #e4e3e3;
		display: flex;
		align-items: center;
		cursor: pointer;
	
	}

	.custom-checkbox input:checked + .label:before {
		background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 10 10'%3E%3Cg class='nc-icon-wrapper' stroke-width='1' fill='%23555555'%3E%3Cpath fill='none' stroke='%23FFFFFF' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' data-cap='butt' d='M2.83 4.72l1.58 1.58 2.83-2.83'/%3E%3C/g%3E%3C/svg%3E");
		background-color: ${Colors.secondary_green_k_medium_1};
		background-position: center;
		border: none;
		padding: 2px;
		cursor: pointer;
		display: flex;
		align-items: center;
	}

	.custom-checkbox input + .label2:before {
		content: "";
		width: ${({typeRadio})=> typeRadio == 'ICP' ? 1 : 1}rem;
		height: ${({typeRadio})=> typeRadio == 'ICP' ? 1 : 1}rem;
		border-radius: 50%;

		display: inline-block;
		vertical-align: middle;
		cursor: pointer;
		display: flex;
		align-items: center;

		background-color: transparent;
		outline: ${({typeRadio})=> typeRadio == 'ICP' ? ` 2px solid ${Colors?.primary_blue_k_main}` : ` 2px solid #63677a`};
		border: 2px solid white;

		margin-left: 0.2rem;
	}

	.custom-checkbox input:checked + .label2:before {
		background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='18' height='18' viewBox='0 0 10 10'%3E%3Cg class='nc-icon-wrapper' stroke-width='1' fill='%23555555'%3E%3Cpath fill='none' stroke='%23FFFFFF' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' data-cap='butt' d='M2.83 4.72l1.58 1.58 2.83-2.83'/%3E%3C/g%3E%3C/svg%3E");
		background-color: ${Colors.secondary_green_k_medium_1};
		background-position: center;
		border: none;
		padding: 2px;
		cursor: pointer;
		display: flex;
		align-items: center;

		width: ${({typeRadio})=> typeRadio == 'ICP' ? 1 : 0.8}rem;
		height:${({typeRadio})=> typeRadio == 'ICP' ? 1 : 0.8}rem;

		background-color: #00d084;
		outline: 2px solid #00d084;
		border: 2px solid white;
		margin-left: 0.2rem;
	}
`;

export const RadioCheck = styled.div`
	display: flex;
`;

export const Question = styled.div`
	font-family: "Roboto";
	font-style: normal;
	font-weight: 400;
	font-size: 1.25rem;
	line-height: 120%;

	color: #404040;

	margin-bottom: 1.8rem;
`;

export const Content = styled.div`
	display: flex;
`;

export const ContentBody = styled.div`
	display: flex;
	flex-direction: column;

	margin-right: 1rem;
`;
